import React from 'react';
import { Card, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

import './ClaimOptionCard.scss';

const { Text } = Typography;

/**
 * Reusable option card for the claim flow.
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon element
 * @param {string} props.title - Card title
 * @param {string} props.description - Card description
 * @param {() => void} props.onClick - Click handler
 * @param {boolean} [props.disabled] - Disable interaction
 * @param {'primary' | 'secondary' | 'reduced'} [props.variant='secondary'] - Visual emphasis
 */
export function ClaimOptionCard({ icon, title, description, onClick, disabled, variant = 'secondary' }) {
  const isPrimary = variant === 'primary';
  const isReduced = variant === 'reduced';

  const bodyPadding = isPrimary ? '24px 28px' : isReduced ? '16px 20px' : '20px 24px';

  return (
    <Card
      hoverable={!disabled}
      onClick={disabled ? undefined : onClick}
      className="claim-option-card"
      style={{
        borderRadius: 12,
        border: isPrimary ? '2px solid #1890ff' : isReduced ? '1px solid #f0f0f0' : '1px solid #e8e8e8',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        height: '100%',
        transition: 'box-shadow .2s, border-color .2s',
        background: isPrimary ? '#f6faff' : undefined,
      }}
      bodyStyle={{
        padding: bodyPadding,
      }}
    >
      <div className="claim-option-card__body">
        <div
          className="claim-option-card__icon"
          style={{
            fontSize: isPrimary ? 32 : isReduced ? 24 : 28,
            color: '#1890ff',
            width: isPrimary ? 56 : isReduced ? 40 : 48,
            height: isPrimary ? 56 : isReduced ? 40 : 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            background: '#f0f5ff',
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div className="claim-option-card__text">
          <Text strong style={{ fontSize: isPrimary ? 18 : isReduced ? 14 : 16, display: 'block' }}>
            {title}
          </Text>
          {description ? (
            <Text type="secondary" style={{ fontSize: isReduced ? 12 : 13, display: 'block' }}>
              {description}
            </Text>
          ) : null}
        </div>
        <ArrowRightOutlined
          className="claim-option-card__arrow"
          style={{ color: '#bbb', fontSize: isPrimary ? 18 : isReduced ? 14 : 16 }}
        />
      </div>
    </Card>
  );
}
